const fixBlocks = document.querySelectorAll('.fixed');
export let isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
        return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
        );
    }
}
const tech = {
    isDevice: () => {
        if (isMobile.any()) {
            document.body.classList.add('_touch');
        } else {
            document.body.classList.add('_pc');
        }
        if (isMobile.iOS()) {
            document.body.classList.add('_ios');
        }
    },
    webP: () => {
        // WEBP
        function addWebP(callback) {
            var webP = new Image();
            webP.onload = webP.onerror = function () {
                callback(webP.height == 2);
            };
            webP.src =
                "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA";
        }

        addWebP(function (support) {
            if (support == true) {
                document.querySelector('body').classList.add('webp');
            } else {
                document.querySelector('body').classList.add('no-webp');
            }
        });
    },
    uniqArray: (array) => {
        return array.filter(function (item, index, self) {
            return self.indexOf(item) === index;
        });
    },
    dataMediaQueries: (array, dataSetValue) => {
        // Получение объектов с медиа запросами
        const media = Array.from(array).filter(function (item, index, self) {
            if (item.dataset[dataSetValue]) {
                return item.dataset[dataSetValue].split(",")[0];
            }
        });
        // Инициализация объектов с медиа запросами
        if (media.length) {
            const breakpointsArray = [];
            media.forEach(item => {
                const params = item.dataset[dataSetValue];
                const breakpoint = {};
                const paramsArray = params.split(",");
                breakpoint.value = paramsArray[0];
                breakpoint.type = paramsArray[1] ? paramsArray[1].trim() : "max";
                breakpoint.item = item;
                breakpointsArray.push(breakpoint);
            });
            // Получаем уникальные брейкпоинты
            let mdQueries = breakpointsArray.map(function (item) {
                return '(' + item.type + "-width: " + item.value + "px)," + item.value + ',' + item.type;
            });
            mdQueries = tech.uniqArray(mdQueries);
            const mdQueriesArray = []

            if (mdQueries.length) {
                // Работаем с каждым брейкпоинтом
                mdQueries.forEach(breakpoint => {
                    const paramsArray = breakpoint.split(",");
                    const mediaBreakpoint = paramsArray[1];
                    const mediaType = paramsArray[2];
                    const matchMedia = window.matchMedia(paramsArray[0]);
                    // Объекты с нужными условиями
                    const itemsArray = breakpointsArray.filter(function (item) {
                        if (item.value === mediaBreakpoint && item.type === mediaType) {
                            return true;
                        }
                    });
                    mdQueriesArray.push({
                        itemsArray,
                        matchMedia
                    })
                });
                return mdQueriesArray;
            }
        }
    },
    slideUp: (target, duration = 500, showmore = 0) => {
        if (!target.classList.contains('_slide')) {
            target.classList.add('_slide');
            target.style.transitionProperty = 'height, margin, padding';
            target.style.transitionDuration = duration + 'ms';
            target.style.height = `${target.offsetHeight}px`;
            target.offsetHeight;
            target.style.overflow = 'hidden';
            target.style.height = showmore ? `${showmore}px` : `0px`;
            target.style.paddingTop = 0;
            target.style.paddingBottom = 0;
            target.style.marginTop = 0;
            target.style.marginBottom = 0;
            window.setTimeout(() => {
                target.hidden = !showmore ? true : false;
                !showmore ? target.style.removeProperty('height') : null;
                target.style.removeProperty('padding-top');
                target.style.removeProperty('padding-bottom');
                target.style.removeProperty('margin-top');
                target.style.removeProperty('margin-bottom');
                !showmore ? target.style.removeProperty('overflow') : null;
                target.style.removeProperty('transition-duration');
                target.style.removeProperty('transition-property');
                target.classList.remove('_slide');
            }, duration);
        }
    },
    slideDown: (target, duration = 500, showmore = 0) => {
        if (!target.classList.contains('_slide')) {
            target.classList.add('_slide');
            target.hidden = target.hidden ? false : null;
            showmore ? target.style.removeProperty('height') : null;
            let height = target.offsetHeight;
            target.style.overflow = 'hidden';
            target.style.height = showmore ? `${showmore}px` : `0px`;
            target.style.paddingTop = 0;
            target.style.paddingBottom = 0;
            target.style.marginTop = 0;
            target.style.marginBottom = 0;
            target.offsetHeight;
            target.style.transitionProperty = "height, margin, padding";
            target.style.transitionDuration = duration + 'ms';
            target.style.height = height + 'px';
            target.style.removeProperty('padding-top');
            target.style.removeProperty('padding-bottom');
            target.style.removeProperty('margin-top');
            target.style.removeProperty('margin-bottom');
            window.setTimeout(() => {
                target.style.removeProperty('height');
                target.style.removeProperty('overflow');
                target.style.removeProperty('transition-duration');
                target.style.removeProperty('transition-property');
                target.classList.remove('_slide');
            }, duration);
        }
    },
    slideToggle: (target, duration = 500) => {
        if (target.hidden) {
            return tech.slideDown(target, duration);
        } else {
            return tech.slideUp(target, duration);
        }
    },
    lockPadding: () => {
        let paddingOffset = window.innerWidth - document.body.offsetWidth + 'px';
        fixBlocks.forEach((el) => {
            el.style.paddingRight = paddingOffset;
        });
        document.body.style.paddingRight = paddingOffset;
    },

    unlockPadding: () => {
        fixBlocks.forEach((el) => {
            el.style.paddingRight = '0px';
        });
        document.body.style.paddingRight = '0px';
    },
    // disable/enable scroll
    disableScroll: () => {
        let pagePosition = window.scrollY;
        lockPadding();
        document.body.classList.add('_disable-scroll');
        document.body.dataset.position = pagePosition;
        document.body.style.top = -pagePosition + 'px';
    },
    enableScroll: () => {
        let pagePosition = parseInt(document.body.dataset.position, 10);
        unlockPadding();
        document.body.style.top = 'auto';
        document.body.classList.remove('_disable-scroll');
        window.scroll({ top: pagePosition, left: 0 });
        document.body.removeAttribute('data-position');
    },
    windowScrollY: () => {
        return window.scrollY;
    },
    scrollHeight: () => {
        return document.documentElement.scrollHeight;
    },

    ifTargetElement: (etarget, elem) => {
        let target;
        // (/\.|#/g) = /\ .  - замінити крапку | - і, або # дієз  #/g
        if (etarget.classList.contains(elem.replace(/\.|#/g, ''))) {
            return target = etarget;
        } else {
            return target = etarget.closest(elem);
        }
    },

    toggleClasses: (selector, classes) => {
        selector = selector || '';
        classes = classes || '';
        if (selector) {
            let classList = selector.classList;
            if (!Array.isArray(classes)) {
                classes = classes.replace(/(,\s*|\s+)/g, ' ').split(' ');
            }
            for (let className of classes) {
                classList.toggle(className);
            }
            return true;
        }
    },
    getCookies: (name) => {
        let matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    },
    setCookies: (name, value, time, days) => {
        let expires = "";
        if (time || time !== 0) {
            let date = new Date();
            date.setTime(date.getTime() + (time * 3600 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        if (days || days !== 0) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
}

export const isDevice = tech.isDevice;
export const webP = tech.webP;
export const dataMediaQueries = tech.dataMediaQueries;
export const slideUp = tech.slideUp;
export const slideDown = tech.slideDown;
export const slideToggle = tech.slideToggle;
export const disableScroll = tech.disableScroll;
export const enableScroll = tech.enableScroll;
export const lockPadding = tech.lockPadding;
export const unlockPadding = tech.unlockPadding;
export const windowScrollY = tech.windowScrollY;
export const scrollHeight = tech.scrollHeight;
export const ifTargetElement = tech.ifTargetElement;
export const toggleClasses = tech.toggleClasses;
export const getCookies = tech.getCookies;
export const setCookies = tech.setCookies;